import React from 'react';

const LoanQuoteStep3 = ({ onNewQuoteClick, supportPhone = '01443 800621' }) => {
    return (
        <div className="lqc-confirmation-card">
            <div className="lqc-success-icon-wrap">
                <div className="lqc-success-icon">
                    <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>
            </div>

            <h3 className="lqc-confirmation-title">Application Submitted Successfully!</h3>
            <p className="lqc-confirmation-subtitle">
                Thank you for applying. We have sent an acknowledgement receipt to your registered email address.
            </p>

            <div className="lqc-roadmap-container">
                <h4 className="lqc-roadmap-title">What Happens Next?</h4>

                <div className="lqc-roadmap-timeline">
                    <div className="lqc-roadmap-step">
                        <div className="lqc-roadmap-marker">
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                                <polyline points="10 9 9 9 8 9" />
                            </svg>
                        </div>
                        <div className="lqc-roadmap-content">
                            <span className="lqc-step-heading">1. Specialist Review</span>
                            <p className="lqc-step-desc">
                                Our finance team will review your application details. (Typically within 2-4 working hours)
                            </p>
                        </div>
                    </div>

                    <div className="lqc-roadmap-step">
                        <div className="lqc-roadmap-marker">
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                            </svg>
                        </div>
                        <div className="lqc-roadmap-content">
                            <span className="lqc-step-heading">2. Quick Follow-Up Call</span>
                            <p className="lqc-step-desc">
                                We will give you a brief, no-hassle phone call to confirm details and answer any questions.
                            </p>
                        </div>
                    </div>

                    <div className="lqc-roadmap-step">
                        <div className="lqc-roadmap-marker">
                            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                            </svg>
                        </div>
                        <div className="lqc-roadmap-content">
                            <span className="lqc-step-heading">3. Approval & Fast Payout</span>
                            <p className="lqc-step-desc">
                                Upon final approval, funds are securely arranged and released directly to complete your financing.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="lqc-support-box">
                <div className="lqc-support-icon">
                    <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                    </svg>
                </div>
                <div className="lqc-support-text">
                    Need urgent assistance? Call our direct team on <strong>{supportPhone || '01443 800621'}</strong> (Mon-Fri 9am-6pm).
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary lqc-new-quote-btn px-4 py-2" onClick={onNewQuoteClick}>
                    Start a New Quote
                </button>
            </div>
        </div>
    );
};

export default LoanQuoteStep3;
